import { AuthContext } from "../context/AuthContextProvider";
import { Routes, Route } from "react-router-dom";
import { CheckLogin } from "../CheckLogin.jsx";
import { RequireAuth } from "../RequireAuth.jsx";
import { LEGAL_DOCUMENTS } from "../constants/legalDocuments";
import Login from "../pages/auth/Login.jsx";
import LoginPassword from "../pages/auth/LoginPassword.jsx";
import EcgReportView from "../pages/EcgReports/ECGReports.jsx";
import CollectionTasks from "../pages/CollectionTask/CollectionTasks.jsx";
import CreateCollectionTasks from "../pages/CollectionTask/CreateCollectionTasks.jsx";
import EditCollectionTasks from "../pages/CollectionTask/EditCollectionTasks.jsx";
import Insights from "../pages/Insights/Insights.jsx";
import ECGFullReports from "../pages/EcgReports/ECGFullReports.jsx";
import CollectingAgents from "../pages/CollectingAgents/CollectingAgents.jsx";
import Clients from "../pages/Clients/Clients.jsx";
import Onboarding from "../pages/Onboarding/index.jsx";
import Settings from "../pages/settings/Settings.jsx";
import Profile from "../pages/settings/Profile.jsx";
import AddPeople from "../pages/settings/AddPeople.jsx";
import AddCentre from "../pages/settings/AddCentre.jsx";
import FAQ from "../pages/HelpCenter/FAQ.jsx";
import OnBoadingToken from "../pages/auth/onBoardingToken.jsx";

import UnAuth from "../pages/auth/UnAuth.jsx";
import OnlineConsultation from "../pages/OnlineConsultation";
import ReferredCases from "../pages/ReferredCases";
import Patients from "../pages/Patients/Patients.jsx";
import PatientsList from "../pages/Patients/PatientsList.jsx";
import Interpretations from "../pages/Interpretation";
import Interpretation from "../pages/Interpretation/FullScreen";
import CentreDetails from "../pages/settings/CentreDetails";
import NotFound from "../pages/404";
import CaseDetails from "../pages/ReferredCases/CaseDetails.jsx";
import Screening from "../pages/Screening";
import ImportOnboarding from "../pages/ImportOnboarding";
import ManageFacilities from "../pages/Facilities/ManageFacilities";
import ViewFacilities from "../pages/Facilities/ViewFacilities";
import AnalyticsPage from "../pages/Analytics";
import Devices from "../pages/Devices";
import LegalPage from "../pages/Legal/LegalPage.jsx";

// Route definitions
const privateRoutes = [
  { path: '/', element: <Insights />, role: ["b2b", "b2b-admin", "b2b-member"], permission: "" },
  { path: '/ecg-reports', element: <EcgReportView />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor"], permission: "canViewReports" },
  { path: '/ecg-reports/:id', element: <ECGFullReports />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor"], permission: "canViewReports" },
  // { path: '/dashboard', element: <Dashboard />,role:["b2b","b2b-admin","b2b-member","b2b-doctor","b2b-viewer"],permission:"" },
  { path: '/test-collections', element: <CollectionTasks />, role: ["b2b", "b2b-admin", "b2b-member"], permission: "canViewRequests" },
  { path: '/new-test-collection', element: <CreateCollectionTasks />, role: ["b2b", "b2b-admin", "b2b-member"], permission: "canManageRequests" },
  { path: '/EditCollectionTasks/:id', element: <EditCollectionTasks />, role: ["b2b", "b2b-admin", "b2b-member"], permission: "canManageRequests" },
  { path: '/dashboard', element: <Insights />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"], permission: "" },
  { path: '/analytics', element: <AnalyticsPage />, role: ["b2b"], permission: "" },
  { path: '/collectingagents', element: <CollectingAgents />, role: ["b2b", "b2b-admin", "b2b-member"] },
  { path: '/clients', element: <Clients />, role: ["b2b", "b2b-admin", "b2b-member"] },
  { path: '/settings', element: <Settings />, role: ["b2b", "b2b-admin", "b2b-member"], permission: "" },
  { path: '/profile', element: <Profile />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"], permission: "" },
  { path: '/settings/:id', element: <Settings />, role: ["b2b", "b2b-admin", "b2b-member"] },
  { path: '/settings/centres/:centreId', element: <CentreDetails />, role: ["b2b", "b2b-admin"] },
  { path: '/patients', element: <PatientsList />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"] },
  { path: '/patients/:id', element: <Patients />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor"] },
  { path: '/add-member', element: <AddPeople />, role: ["b2b", "b2b-admin", "b2b-member"], permission: "canManageUsers" },
  { path: '/add-centre', element: <AddCentre />, role: ["b2b", "b2b-admin"] },
  { path: '/help-center', element: <FAQ />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"] },
  { path: '/onlineconsultation/:id', element: <OnlineConsultation />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor"] },
  { path: '/cases', element: <ReferredCases />, role: ["b2b", "b2b-admin", "b2b-doctor"] },
  { path: '/cases/:reportId', element: <CaseDetails />, role: ["b2b", "b2b-admin", "b2b-doctor"] },
  { path: '/interpretation', element: <Interpretations />, role: ["b2b", "b2b-admin", "b2b-doctor"] },
  { path: '/interpretation/:id', element: <Interpretation />, role: ["b2b", "b2b-admin", "b2b-doctor"] },
  { path: '/screening', element: <Screening />, role: ["b2b", "b2b-admin", "b2b-doctor"], permission: "" },
  { path: '/devices', element: <Devices />, role: ["b2b"], permission: "" },
  { path: '/import-onboarding', element: <ImportOnboarding />, role: ["b2b"], permission: "" },
  { path: '/facilities', element: <ViewFacilities />, role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"], permission: "" },
  { path: '/manage-facilities', element: <ManageFacilities />, role: ["b2b", "b2b-admin"], permission: "" },
  { path: '/unauth', element: <UnAuth />, role: ["b2b", "b2b-admin", "b2b-member"] },
  { path: '/onboarding/:id', element: <Onboarding />, header: 'no', role: ["b2b", "b2b-admin", "b2b-member", "b2b-doctor", "b2b-viewer"] },
];

const publicRoutes = [
  { path: '/validate/:id', element: <OnBoadingToken /> },
  { path: '/login', element: <Login />, wrapper: 'checkLogin' },
  { path: '/loginpassword', element: <LoginPassword />, wrapper: 'checkLogin' },
  ...LEGAL_DOCUMENTS.map((doc) => ({
    path: doc.path,
    element: <LegalPage doc={doc} />,
  })),
];

// Route component
const AppRoutes = () => {
  return (
    <>
      <Routes>
        {/* Private Routes */}
        {privateRoutes.map(({ path, role, element, permission, header }, index) => (
          <Route
            key={index}
            path={path}
            element={
              <RequireAuth role={role} gaurd_type="page" permission={permission} header={header} >{element}</RequireAuth>
            }
          />
        ))}

        {/* Public Routes */}
        {publicRoutes.map(({ path, element, wrapper }, index) => {
          let wrappedElement = element;
          if (wrapper === 'checkLogin') {
            wrappedElement = <CheckLogin>{element}</CheckLogin>;
          }
          return <Route key={`public-${index}`} path={path} element={wrappedElement} />;
        })}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>


  );
};

export default AppRoutes;
